var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1178 55.8823 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8823 16.1178 72 36 72Z",
    fill: "#F3BA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4463 45.6809L51.4414 45.6834L36 61.1273L20.5611 45.6884L20.5536 45.6809L26.2391 40.0104L36 49.7687L45.7633 40.0054L51.4463 45.6809Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4413 26.3164L45.7633 31.9945L35.9999 22.2311L26.2391 31.9895L20.561 26.3115L35.9999 10.8726L51.4413 26.3164Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4488 30.3247L49.77 36.0034L55.4488 41.6822L61.1275 36.0034L55.4488 30.3247Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5512 30.3218L10.8724 36.0005L16.5512 41.6792L22.2299 36.0005L16.5512 30.3218Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7605 35.9977H41.763L36.0002 30.2349L31.7429 34.4922L31.2544 34.9807L30.2449 35.9902L30.2374 35.9977L30.2449 36.0051L36.0027 41.7629L41.7655 36.0001L41.768 35.9977H41.7605Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogo);
export default __webpack_public_path__ + "static/media/BinanceLogo.383747ae.svg";
export { ForwardRef as ReactComponent };